var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "c-button",
    _vm._g(
      _vm._b(
        {
          staticClass: "custom-button",
          attrs: {
            padding:
              _vm.padding ||
              {
                pure: "24px 48px",
                border: "20px 48px",
              }[_vm.type],
          },
        },
        "c-button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }